<template>
    <div class="sustainable-component competence-print-summary">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-print-summary</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col col-md-6">
                    <v-select bg-color="white" variant="outlined" label="Anställd" :items="employees" v-model="selectedEmployeeId" item-title="CompleteName" item-value="EmployeeId"></v-select>
                </div>
                <div class="col col-md-6">
                    <a href="javascript:void(0)" @click="printEmployeeCompetences">Visa individens utbildningar</a>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col col-md-6">
                    <a href="javascript:void(0)" @click="printAllEmployeeCompetencesByJobPosition">Visa alla individers utbildningar inom befattningen</a><br />
                    <a href="javascript:void(0)" @click="printAllCompetence">Visa samtliga individers utbildningar</a><br />
                    <a href="javascript:void(0)" @click="downloadCompetenceMatrixAsExcel">Visa kompetensmatris</a>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {

        name: 'competence-print-summary',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadEmployees() {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromCompany("Fornamn");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printEmployeeCompetencies() {
                var selectedEmployeeId = this.selectedEmployeeId;
                if (selectedEmployeeId == null || selectedEmployeeId == "null")
                    selectedEmployeeId = "";
                this.newWindow = window.open('/competenceprint/PrintIndividualDevelopmentplan?employeeId=' + selectedEmployeeId, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            printEmployeeCompetences() {
                if (this.selectedEmployeeId == null) {
                    alert("Välj anställd")
                    return;
                }
                this.newWindow = window.open('/competenceprint/PrintEmployeeEducation?employeeId=' + this.selectedEmployeeId, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            printAllEmployeeCompetencesByJobPosition() {
                if (this.selectedPosition == null) {
                    alert("Välj en befattning")
                    return;
                }
                this.newWindow = window.open('/competenceprint/PrintAllEmployeeEducationByJobPosition?jobPositionId=' + this.selectedPosition , '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            printAllCompetence() {
                this.newWindow = window.open('/competenceprint/PrintAllEmployeeEducation', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async downloadCompetenceMatrixAsExcel() {
                if (this.selectedPosition == null) {
                    alert("Välj en befattning")
                    return;
                }
                location.href = '/WageSettingsExcel/ExportCompetenceMatrix?jobPositionId=' + this.selectedPosition;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                selectedPosition:null,
                selectedEmployeeId:null,
                employees:[],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},

        },
        mounted() {
            this.internalModel = this.model;
            this.loadEmployees();
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
